<section class="main-wrap inner-views dashboard-wrap new-sidebar" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap no-filters">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container respirators">
      <div class="row">
        <div class="col-md-12 dash-title">
          <h1>
            Respirator Inserts
            <!--   <button [routerLink]="['../favorites']" class="btn favorites" type="button">
            Favorites
            <span>
              <img height="20" src="assets/images/icons/heart-filled-25x25.svg" width="20" alt="Favorites Icon"/>
            </span>
          </button> -->
        </h1>
      </div>
      <div class="clearfix"></div>
      @for (ri of respiratoryInserts; track $index; let i = $index) {
        <div class="col-md-4">
          <div class="shop-tile">
            <div class="carousel slide carousel-fade" data-interval="false" data-ride="carousel" id="product_{{i}}"> <!-- INSERT ID HERE -->
              <ol class="carousel-indicators">
                <!-- INSERT COLORS HERE -->
                <!-- <ng-container *ngFor="let color of fp.availableColors; let k = index">
                <li [ngClass]="k == 0 ? 'active' : ''" [attr.data-slide-to]="k" [attr.data-target]="'#product_' + i"><span class="product-color" [ngClass]="getColorClass(color)"></span></li>
              </ng-container> -->
              <!-- END OF INSERT COLORS -->
              <!--              <span class="favorite">
              <svg height="20" id="Layer_1" style="enable-background:new 0 0 25 25;" version="1.1" viewBox="0 0 25 25"
                width="20" x="0px"
                xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
                      <path class="st0" d="M54.6-25.5c-1.8-1.4-4.4-1.3-6,0.4L48-24.4l-0.6-0.6c-1.6-1.7-4.2-1.9-6-0.4
                                        c-1.9,1.7-2.1,4.6-0.5,6.5c0.1,0.1,0.1,0.1,0.2,0.2l6.2,6.4c0.4,0.4,1,0.4,1.4,0c0,0,0,0,0,0l6.2-6.4c1.8-1.8,1.7-4.7-0.1-6.5
                                        C54.7-25.4,54.6-25.5,54.6-25.5z" id="heart"/>
                      <path class="st1" d="M19.1,6.3c-1.8-1.4-4.4-1.3-6,0.4l-0.6,0.6
                                        l-0.6-0.6c-1.6-1.7-4.2-1.9-6-0.4C4,8,3.8,10.9,5.4,12.8c0.1,0.1,0.1,0.1,0.2,0.2l6.2,6.4c0.4,0.4,1,0.4,1.4,0c0,0,0,0,0,0l6.2-6.4
                                        c1.8-1.8,1.7-4.7-0.1-6.5C19.2,6.4,19.1,6.4,19.1,6.3z" id="heart_1"/>
              </svg>
            </span> -->
          </ol>
          <!-- CAROUSEL COLOR PREVIEW -->
          <div class="carousel-inner">
            <div class="carousel-item active">
              <a [routerLink]="['/products/respirators', ri.style]" (click)="selectProduct(ri.respiratorInsertId, ri.style)"><img class="d-block w-100" src="https://storage.googleapis.com/eyelation_images/Products/Respirator Inserts/{{ri.imageName}}" alt="Product Hidx Orange"/></a>
            </div>
          </div>
          <!-- END OF CAROUSEL COLOR PREVIEW -->
        </div>
        <h3>{{ri.style}} <span class="app-price">{{ri.price | currency}}</span></h3>
        <!-- ADDITIONAL INFO NOT SUPPLIED HERE -->
        <!-- <a class="tile-link" href="">{{ri.}}</a> -->
      </div>
    </div>
  }
</div>
</div>
</div>
</section>
